import * as React from 'react';

import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import { Input } from './input';

export const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, ...props }, ref) => {
    const { t } = useTranslation('common');
    const [isVisible, setIsVisible] = React.useState(false);

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={isVisible ? 'text' : 'password'}
          className={cn('pr-4', className)}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          aria-label={isVisible ? t('hidePassword') : t('showPassword')}
          onClick={() => setIsVisible(isVisible => !isVisible)}
          className="absolute right-0 top-1/2 -translate-y-1/2 p-3 text-muted-foreground hover:text-foreground focus:outline-none"
        >
          {isVisible ? <EyeOffIcon className="size-4" /> : <EyeIcon className="size-4" />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = 'PasswordInput';
